import axiosApi from './common/api';

const baseAPI = 'links/';

class LinkService {

  insertItem(item: any, type: string) {
    return axiosApi.post(baseAPI, { item, "type": type });
  }

  updateItem(id: string, item: object) {
    return axiosApi.put(baseAPI + id, { item });
  }

  deleteItem(id: string) {
    return axiosApi.delete(baseAPI + id);
  }

  getLinks(skip: number, limit: number, search: string) {
    try {
        let url = baseAPI + `?__skip=${skip}&__limit=${limit}`;
        if (search?.length > 0) 
          url += `&__search=${search}`;
        return axiosApi.get(url).then((response: Response) => {
          return response;
        });
    } catch (error) {
      console.error("Error fetching links:", error);
      throw error;
    }    
  }

  getLinksByPath(path: string) {
    try {
        return axiosApi.get(baseAPI + `path/${encodeURIComponent(path)}`).then((response: Response) => {
          return response;
        });
    } catch (error) {
      console.error("Error fetching links:", error);
      throw error;
    }    
  }
  getActiveLinks(skip: number, limit: number, search: string, categories: string[]) {
    try {

        let url = baseAPI + "active" + `?__skip=${skip}&__limit=${limit}`;
        if (categories && categories.length > 0) {
          url = url + "&__categories=" + encodeURIComponent(categories.join(","));
        }
        if (search?.length > 0) {
          url = url + "&__search=" + encodeURIComponent(search);
        }
        return axiosApi.get(url).then((response: Response) => {
          return response;
        });
    } catch (error) {
      console.error("Error fetching links:", error);
      throw error;
    }    
  } 

  getStats() {
      return axiosApi.get(baseAPI + "count").then((response: Response) => {
        return response;
      }).catch((error: any) => {
        throw error;
      });
  }

  getItemById(id: string) {
    try {
        return axiosApi.get(baseAPI + id).then((response: Response) => {
          return response;
        });
    } catch (error) {
      console.error("Error fetching links:", error);
      throw error;
    }    
  } 
}

export default new LinkService();